import { Injectable, inject } from '@angular/core';
import { CanMatch, UrlTree } from '@angular/router';
import { Observable, take, map } from 'rxjs';
import { Store } from '@ngrx/store';

import { AuthActions, LocationPermissionsService } from '@midas/shared/data-access';

@Injectable({ providedIn: 'root' })
export class ControlZoneGuard implements CanMatch {
  private readonly store = inject(Store);
  constructor(private locationPermissionsService: LocationPermissionsService) {}

  canMatch(): Observable<boolean | UrlTree> {
    return this.locationPermissionsService.checkTenantLocationPermissionsForControlZone().pipe(
      take(1),
      map((validation: boolean) => {
        if (!validation) {
          this.store.dispatch(AuthActions.loginGroupAccessError());
        }
        return validation;
      }),
    );
  }
}
